import { inject } from '@angular/core'
import { ResolveFn, Router, UrlTree } from '@angular/router'
import { tap } from 'rxjs/operators'
import { Store, select } from '@ngrx/store'
import { AuthService } from '@core/service/auth.service'
import { selectRouteData } from '@core/store/selectors/router.selector'
import { Observable } from 'rxjs'

/**
 * The attempt to navigate a user to a specific page based on application settings.
 */

export const applicationSettingsGuard: ResolveFn<Observable<boolean | UrlTree>> = () => {
  const store = inject(Store)
  const router = inject(Router)
  const authService = inject(AuthService)

  return store.pipe(
    select(selectRouteData),
    tap((routeData: any) => {
      const requiredSettings = routeData?.settings
      const hasSettings =
        !requiredSettings ||
        requiredSettings.some((setting: string) => authService.loggedInUser?.company.hasApplicationSetting(setting))
      return hasSettings ? true : router.parseUrl('/unauthorised')
    })
  )
}
